import React, { useEffect, useState } from 'react';
import CardSlotV2 from '@/pages/intelligence/components/CardSlotV2';
import ChartsIndex from '@/pages/intelligence/components/ChartsComponents/ChartsIndex';
import useBarCharts from '@/pages/intelligence/components/Chart/hooks/useBarCharts';
import useNewGameBarCharts from '@/pages/intelligence/pages/Following/_hook/useCommonBarCharts';
import { useIntl } from 'umi';

export default function NewGamesVisualis(props: any) {
  const { formatMessage } = useIntl();

  const { barOrPieData, entityType, loading, cardSlotTitle, fetchParams } = props;
  const [chartType, setChartType] = useState('bar');

  // 柱状图相关hooks
  const { seriesData: barSeriesData, barNameList } = useNewGameBarCharts(
    'potential',
    barOrPieData,
  );
  const [chartLoading, setChartLoading] = useState(true);
  //获取柱状图hooks
  const { barOption } = useBarCharts({
    seriesData: barSeriesData,
    setChartLoading,
    barOrPieData: barOrPieData,
    titleNow: formatMessage({
      id: `dbi_top_pheat`,
    }),
    dataSourceEachers: [],
    barNameList,
    gameIdKeyName: 'id',
    imageType: entityType,
    ifNeedSourceImg: false,
    startDate: fetchParams?.start_date,
    endDate: fetchParams?.end_date,
    // cardWidth: cardRef?.current?.clientWidth
  });
  return (
    <>
      <CardSlotV2
        title={cardSlotTitle}
        className="dbi-following-card"
        disableChartType={['line', 'pie']}
        activeTab={chartType}
      >
        <div className="data-chart">
          <ChartsIndex
            chartLoading={chartLoading || loading}
            barOption={{
              ...barOption,
              grid: {
                left: '5px',
                right: '0%',
                top: '25px',
                bottom: '3px',
                containLabel: true,
              },
            }}
            lineOption={null}
            chartType={chartType}
            isNodata={!barOrPieData?.length}
          />
        </div>
      </CardSlotV2>
    </>
  );
}
